import { z } from 'zod'
import { DiagnosticCard } from '~/shared/api'

export const formSchema = DiagnosticCard.schema.pick({
  number: true,
  issuedDate: true,
  expirationDate: true,
})

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = TypeFormSchema
